import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import AnchorPage from '../../pages/AnchorPage/AnchorPage';
import BlogPage from '../../pages/Blogs/Blog/Blog';
import ArchivesPage from '../../pages/Archives/Archives';
import { UserContext } from '../../context';


const RoutesWithSlugPath = ({ activeCampaign, anchorPortalCampaign }) => {
  const user = React.useContext(UserContext);

  return (
    <Route
      exact={true}
      path="/:slug*"
      render={({ match, location, history }) => {
        if (!user.authenticated && !window.location.hostname.includes('nakednews')) {
          return <Redirect to={{ pathname: '/tour' }} />;
        }
        if ('live' === match.params.slug) {
          return (
            <AnchorPage
              key="live1"
              activeCampaign={activeCampaign}
              anchorPortalCampaign={anchorPortalCampaign}
              history={history}
              isLive={true}
              location={location}
              slug={match.params.slug}
              user={user}
            />
          );
        }
        if (/(^naked-news-anchor-)/.test(match.params.slug)) {
          return (
            <AnchorPage
              key={match.params.slug}
              activeCampaign={activeCampaign}
              anchorPortalCampaign={anchorPortalCampaign}
              history={history}
              location={location}
              slug={match.params.slug}
              user={user}
            />
          );
        }
        const pathname = location.search ? `${location.pathname}${location.search}` : match.params.slug;

        location.pathname = pathname;

        if (/(---\d+)/.test(pathname)) {
          return (
            <BlogPage location={location} slug={match.params.slug} user={user} />
          );
        }
        if (
          /(-w\d{1,})/.test(match.params.slug) ||
          /(-v(\d)*)/.test(match.params.slug) ||
          /(\/nude-program)/.test(match.params.slug) ||
          /(\d\d\d\d\/\d\d)/.test(match.params.slug)
        ) {
          return (
            <ArchivesPage
              history={history}
              location={location}
              slug={match.params.slug}
              user={user}
            />
          );
        }

        return (<ArchivesPage
          history={history}
          location={location}
          match={match}
          user={user}
        />);
      }}
    />
  );
};

export default RoutesWithSlugPath;
